export default {
  "content": "<g clip-path=\"url(#a)\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.114 4.341L7.348.927C7.673.586 7.443 0 6.984 0H.515C.058 0-.172.586.151.927l3.235 3.414c.2.212.527.212.728 0z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h7.5v4.5H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "8",
    "height": "5",
    "fill": "none",
    "viewBox": "0 0 8 5"
  }
};